import { Meta } from 'aimo-ui';
import { format } from 'date-fns';
import React from 'react';
import {
  Maybe,
  SalesOrderStatus,
  UnifiedPermit,
} from 'types/generatedSchemaTypes';
import RemainingValidityIndicator from '../RemainingValidityIndicator';

const ValidityDateRow = ({
  permit,
  orderStatus,
  endDate,
  isRecurring,
  isInvoicing,
  nextBillingDate,
  uid,
  isWaiting,
}: {
  permit: UnifiedPermit;
  orderStatus?: Maybe<SalesOrderStatus>;
  endDate?: Maybe<string>;
  isRecurring?: boolean;
  isInvoicing?: boolean;
  nextBillingDate?: Date;
  uid?: string;
  isWaiting?: boolean;
}) => {
  const getExpirationDate = (): Maybe<string> | undefined => {
    if (isInvoicing) {
      return endDate;
    }
    return nextBillingDate?.toDateString();
  };

  if (
    (orderStatus === 'TERMINATED' || orderStatus === 'TERMINATING') &&
    !!endDate
  ) {
    const date = new Date(endDate);
    if (!Number.isNaN(date.getTime())) {
      return (
        <Meta testID={`permit-${permit.id}-renewal`}>
          {format(date, 'd.M.y')}
        </Meta>
      );
    }
  }

  return (
    <RemainingValidityIndicator
      isRecurring={!!isRecurring}
      expirationDate={getExpirationDate()}
      permitStatus={orderStatus}
      permitId={uid ?? ''}
      isWaiting={isWaiting}
      predefinedEndDate={endDate}
    />
  );
};

export default ValidityDateRow;
